import React from "react";
import Swiper from "react-id-swiper";

class IllPackUs extends React.Component {
  render() {
    const params = {
      effect: "coverflow",
      grabCursor: true,
      initialSlide: 2,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      slidesPerView: 4,
      pagination: {},
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1.43,
        slideShadows: false
      },
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        360: {
          slidesPerView: 1,
          coverflowEffect: {
            depth: 50,
            modifier: 0
          }
        },
        640: {
          slidesPerView: 3,
          coverflowEffect: {
            depth: 80,
            modifier: 0
          }
        }
      }
    };

    return (
      <section id="ill-pack-us" className="theme-bg-ill-pack-us screenshots">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title">
                <h2>
                  <a 
                    href="https://illpackus.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="illpackus-logo"
                      src="https://cdn.johnbernazzani.com/illpackus.png"
                      alt="1"
                    />
                  </a>
                </h2>
                <p className="text-white">(personal)</p>
                <img
                  src="https://cdn.johnbernazzani.com/white-line.svg"
                  alt="title-line"
                  className="img-fluid title-line"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Swiper
                {...params}
                className="swiper-screenshots-container-1 swiper-container"
              >
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/trip_home_expanded.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/chat.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/itinerary.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/payments.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/explore_2.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/trip_home.png" alt="1" />
                </div>
                <div className="swiper-slide">
                  <img src="https://cdn.johnbernazzani.com/mockups/illpackus/my_trips.png" alt="1" />
                </div>
              </Swiper>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center app-description">
              <h1>
                <i className="fa fa-desktop" /> + <i className="fa fa-mobile" />
              </h1>
              <p>
                A mobile and web app designed for making group trip planning fun
                again. Features include budget planning, itinerary scheduling,
                in-app chat, photo sharing, and destination exploring.
              </p>
              <a
                href="https://illpackus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">Learn More</button>
              </a>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p className="text-white">Available Soon On</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="app-store-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/app_store.png" alt="1" />
            </div>
            <div className="app-store-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/google_play.png" alt="1" />
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p>Crafted with</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/ionic.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/angular.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bootstrap.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/node.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/mongodb.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/aws.png" alt="1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default IllPackUs;



// WEBPACK FOOTER //
// ./src/components/ill-pack-us.js